<template lang="html">
  <div class="CouponItem">
    <div class="info">
      <p class="firstLine">
        <span class="money">{{Number(this.couponData.rewardAmount) / 100 || ''}}</span>
        <span class="unit">{{couponData.rewardIcon}}</span>
      </p>
      <div class="secondLine">
        <span class="name">{{couponData.rewardName[0]}}</span>
        <div v-if="!!couponData.rewardName[1]" class="tag">
          <span class="tagText">{{couponData.rewardName[1]}}</span>
        </div>
      </div>
    </div>
    <div class="operate">
      <a :clstag="clstag" @click="handleClick()" :class="{'shake': animate && animatedIndex[couponIndex]}">{{buttonText}}</a>
    </div>
  </div>
</template>

<script>
import * as api from '@/api'
import { getRiskData } from '@/public/getRiskData'
import * as util from '@/public/util'
import _ from 'lodash'
import { Toast } from 'mint-ui';

const throttleTime = 500
let {
  actCode,
  source,
  markId,
  pin,
} = util.parseUrlSearchToObj()

export default {
  name: 'CouponItem',

  props: ['couponData', "couponIndex",'isBuilder'],

  data () {
    return {
      isJdjr: $.device.jdjr,
      contents: window.contentData.contents || {},
      animate: false,
      animatedIndex: null,
    }
  },

  computed: {
    clstag () {
      let result
      let status = Number(this.couponData.rewardStatus)

      if (status === 2) { // 立即使用
        if (this.isBuilder) { // 分享者
          if ($.device.jdjr) { // 站内
            result = 'jr|keycount|zy|fxznsy'
          } else { // 站外
            result = 'jr|keycount|zy|fxzwsy'
          }
        } else { // 参与者
          if ($.device.jdjr) { // 站内
            result = 'jr|keycount|zy|cyznsy'
          } else { // 站外
            result = 'jr|keycount|zy|cyzwsy'
          }
        }
      } else { // 去领取
        if (this.isBuilder) { // 分享者
          if ($.device.jdjr) { // 站内
            result = 'jr|keycount|zy|fxznjh'
          } else { // 站外
            result = 'jr|keycount|zy|fxzwjh'
          }
        } else { // 参与者
          if ($.device.jdjr) { // 站内
            result = 'jr|keycount|zy|cyznjh'
          } else { // 站外
            result = 'jr|keycount|zy|cyzwjh'
          }
        }
      }

      return result
    },
    buttonText () {
      let status = Number(this.couponData.rewardStatus)
      let result = status === 2 ? this.contents.couponBtnReceived : this.contents.couponBtnUnreceived

      return result
    },
  },

  mounted () {
    this.delayShowToast()
  },

  methods: {
    handleClick: _.throttle(function clickCoupon () {
      this.animate = false

      const [linkIn, linkOut] = this.couponData.rewardURL
      if ($.device.jdjr) {

        this.useTicket(linkIn)
      } else {
        if (linkOut) {
          this.sendReward().then(res => {
            window.location.href = linkOut
          })
        } else {
          this.jumpToApp()
        }
      }
    }, throttleTime),
    delayShowToast () {
      let params = {
        reqData: JSON.stringify({
          source,
          ukey: markId,
          actCode,
        })
      }
      const {delayTime = -1, delayText} = this.contents

      if (Number(delayTime) >= 0) {
        setTimeout(() => {
          api.getCouponList(params).then(couponList => {
            let animatedIndex = []
            let allRewarded = couponList.every(item => {
              let hasReward = (item.rewardStatus == 2)
              animatedIndex.push(!hasReward)

              return hasReward
            })
            if (!allRewarded) {
              Toast({
                message: delayText,
                // message: '激活了优惠券才算参团哦',
                position: 'top',
                duration: 2000
              })

              this.animate = true
              this.animatedIndex = animatedIndex
            }
          })

        }, Number(delayTime) * 1000)
      }
    },
    jumpToApp () {
      let link = util.isCeshi ? this.contents.awakeCeshi : this.contents.awake
      window.location.href = link
    },
    useTicket (jumpUrl) {
      let status = Number(this.couponData.rewardStatus) // 是否已发奖
      if (status === 2) {
        this.redirectUrl(jumpUrl)
        return
      }

      this.sendReward().then(res => {
        this.redirectUrl(jumpUrl)
      })

    },
    sendReward () {
      let params = {
        actCode,
        source,
        ukey: markId,
        riskDeviceParam: JSON.stringify(getRiskData())
      }

      return api.sendReward({
        reqData:JSON.stringify(params)
      }).then(resultData => {
        this.$emit('sendReward:success')

        return resultData
      })
    },
    redirectUrl(link){
      try {
        let defer = jsBridgeV3.onReady();
        defer.then(function (res) {
          this.jsOpenWeb({
              jumpUrl: link,
              jumpType: 8,
              productId: '',
              isclose: false
          });
        });
      } catch (e) {}
    },
  }
}
</script>

<style media="screen">
@keyframes shake {
  from,
  to {
    transform: translate3d(0, 0, 0);
  }

  1%, 3%, 5%, 7%{
    transform: translate3d(0, -2px, 0);
  }

  2%, 4%, 6%, 8% {
    transform: translate3d(0, 2px, 0);
  }

  9% {
    transform: translate3d(0, 0, 0);
  }

}

.shake {
  animation-name: shake;
  animation-duration: 5s;
  animation-fill-mode: both;
  animation-iteration-count: infinite;
  animation-delay: 2s;
}
</style>

<style lang="scss" scoped>
.CouponItem{
  display: flex;
  display: -webkit-flex;
  align-items:center;
  -webkit-align-items: center;
  // padding: 7px 0px;
  // background-color: #FD5B5B;
  width: 285px;
  height: 88px;
  box-sizing: border-box;
  font-family: 'PingFangSC-Semibold';
  background-image: url(./coupon-bg.png);
  background-size: 285px 88px;
  background-position: center;
  background-repeat: no-repeat;
  margin-top: 6px;

  &:first-child{
    margin-top: 0px;
  }

  .info{
    width: 171px;
    // background-color: #ccc;
    // padding-top: 25px;
    box-sizing: border-box;
    padding-left: 25px;
    text-align: left;

    .unit{
      font-family: PingFangSC-Semibold;
      font-size: 24px;
      color: #FFFFFF;
      letter-spacing: 0;
      text-align: center;
      line-height: 40px;
    }
    .firstLine{
      // margin-bottom: 7px;
      // background-color: rgba(0,0,0,0.5);
    }
    .money{
      font-size: 34px;
      font-family: PingFangSC-Semibold;
      color: #FFFFFF;
      letter-spacing: 0;
      text-align: center;
    }
    .secondLine{
      display: flex;
      display: -webkit-flex;
      height: 25px;
      justify-content: center;
      -webkit-justify-content: center;
      align-items:center;
      -webkit-align-items: center;
      font-family: 'PingFang-SC-Regular';
    }
    .name{
      font-size: 14px;
      color: #FFDCC4;
      margin-right: 4px;
    }
    .tag{
      display: inline-block;
      box-sizing: border-box;
      font-size: 0px;
      // font-size: 10px;
      // line-height: 14px;
      // height: 15px;
      border: 0.5px solid #FFDCC4;
      // border-radius: 0.5px;
      // color: #FFDCC4;
      // padding: 2px 2px;
      // margin: 1px;
      // max-width: 90px;
      // white-space: nowrap;
    }
    .tagText{
      display: inline-block;
      font-size: 10px;
      // line-height: 14px;
      // height: 15px;
      // border: 0.5px solid #FFDCC4;
      // border-radius: 1px;
      color: #FFDCC4;
      padding: 2px 2px;
      // max-width: 85px;
      white-space: nowrap;
      // background-color: red;
      // margin: 2px;
    }
    // .tag{
    //   display: inline-block;
    //   box-sizing: border-box;
    //   font-size: 10px;
    //   line-height: 14px;
    //   // height: 15px;
    //   border: 0.5px solid #FFDCC4;
    //   border-radius: 1px;
    //   padding-right: 1px;
    //   color: #FFDCC4;
    //   padding: 2px 2px;
    //   margin: 1px;
    //   max-width: 90px;
    //   white-space: nowrap;
    // }

  }
  .operate{
    width: 113px;
    height: 100%;
    // background-color: #ccc;
    // border-left: 1px dashed #CE0000;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    -webkit-justify-content: center;
    align-items:center;
    -webkit-align-items: center;
    font-family: 'PingFang-SC-Regular';


    a{
      display: block;
      background-color: rgba(255,255,255,0.2);
      border: none;
      outline: none;
      border-radius: 14px;
      width: 74px;
      height: 28px;
      line-height: 28px;
      color: #fff;
      text-decoration: none;
      font-size: 12px;
      letter-spacing: 0;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CouponItem/index.vue